import i18n from "../../../../../i18n"
import ArrayTable from "../../../../../UI/ArrayTable/ArrayTable"
import {euroFormatter, imageFormatter} from "../../../../../functions/Formatters/formatters"
const ReservationPrice = (props) => {
    const table = {
        'product_object.image_object':{
            'label': '',
            'formatter': (value, row, id) => {
                if(value){
                    return <img className="small-image" src={value.image_webp} />
                }
            },
        }, 
        'description':{
            'label': i18n.t('Omschrijving'),
            'formatter': (value, row, id) => {
                if(row.parent_line){
                    return <span className="ps-2">+ {value}</span>
                }
                return <span className="">{value}</span>
            }
        }, 
        'quantity':{
            'label': i18n.t('Aantal'),
            'formatter': (value, row, id) => {
                if(row.unit === 'pc'){
                    return <span className="ps-2">{value * 100}%</span>
                }
                return <span className="">{value}</span>
            }
        }, 
        'amount_in_vat': {
            'label': i18n.t('Bedrag'),
            'formatter':euroFormatter,
            'className':'text-end'
        },       
    }
    if(props.data.reservationline_objects.filter(line => line.people > 0).length > 0){
        table['people'] = {
            'label': i18n.t('Gasten')
        }
    }

    const lines = <ArrayTable className="reservation-table table table-hover m-0" data={props.data.reservationline_objects.filter(line => line.total_amount_in_vat !== 0)} fields={table} >
            {/* <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('Subtotaal')}: {euroFormatter(props.data.total_amount_ex_vat)}</td> </tr>
            <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('BTW')}: {euroFormatter(props.data.total_amount_vat)}</td> </tr> */}
            <tr> <td colSpan={'100%'} className="text-end"> {i18n.t('Totaal')}: {euroFormatter(props.data.total_amount_in_vat)}</td> </tr>
        </ArrayTable>
    return <>
        {lines}

    </>
}

export default ReservationPrice